import React from 'react';
import styles from './Contact.module.css';

const Contact = () => {
  return (
    <section id="contact" className={styles.contact}>
      <div className={styles.container}>
        <h2 className={styles.title}>Order Now</h2>
        <p className={styles.subtitle}>હમણાં જ ઓર્ડર કરો</p>
        <p className={styles.orderNote}>📦 Delivery & Takeaway Only • No Dine-In Available</p>

        <div className={styles.content}>
          <div className={styles.infoSection}>
            <div className={styles.infoCard}>
              <div className={styles.cardIcon}>🍽️</div>
              <h3 className={styles.cardTitle}>Janki's Cloud Kitchen</h3>
              <p className={styles.cardSubtitle}>Matrubhav</p>
            </div>

            <div className={styles.infoCard}>
              <div className={styles.cardIcon}>📱</div>
              <h3 className={styles.cardTitle}>Phone Number</h3>
              {/* <a href="tel:+919601399999" className={styles.phone}>+91 96013 99999</a> */}
              <a href="tel:+918183934567" className={styles.phone}>+91 81839 34567</a>
            </div>

            <div className={styles.infoCard}>
              <div className={styles.cardIcon}>📧</div>
              <h3 className={styles.cardTitle}>Email</h3>
              <a href="mailto:taste@jankiscloudkitchen.in" className={styles.email}>taste@jankiscloudkitchen.in</a>
            </div>

            <div className={styles.infoCard}>
              <div className={styles.cardIcon}>📍</div>
              <h3 className={styles.cardTitle}>Pickup Address</h3>
              <p className={styles.address}>
                Jivan Nagar Street No. 5<br />
                Near Raiya Circle<br />
                Behind West Gate<br />
                Rajkot – 360007
              </p>
              <p className={styles.pickupNote}>⚠️ Takeaway Only</p>
            </div>

            {/* <a 
              href="https://wa.me/919601399999" 
              target="_blank" 
              rel="noopener noreferrer"
              className={styles.whatsappBtn}
            >
              <span className={styles.whatsappIcon}>💬</span>
              Order on WhatsApp
            </a> */}
          </div>

          <div className={styles.mapSection}>
            <iframe
              title="Janki's Cloud Kitchen Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.5!2d70.7833!3d22.3039!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjLCsDE4JzE0LjAiTiA3MMKwNDYnNTkuOSJF!5e0!3m2!1sen!2sin!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0, borderRadius: '20px' }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
